import { render, staticRenderFns } from "./sub-staff-tab.vue?vue&type=template&id=53eace5a&scoped=true"
import script from "./sub-staff-tab.vue?vue&type=script&lang=js"
export * from "./sub-staff-tab.vue?vue&type=script&lang=js"
import style0 from "./sub-staff-tab.vue?vue&type=style&index=0&id=53eace5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eace5a",
  null
  
)

export default component.exports